import React, { Component } from "react";

import AdminVerifiedContentTable from "./AdminVerifiedContentTable";
import { adminVerifiedService } from "./services/adminVerifiedContent.service";
import { toast } from "react-toastify";

class ManageAdminVerifiedContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fetching: false,
      submitting: false,
      formError: null,
      data: null,
      selectedRow: null,
      hasParams: false,
      error: null,
      pageNum: 0,
      pageSize: 10,
      showModal: false,
      notResetMode: false,
      showNextJoyRide: false
    };
  }
  componentDidMount() {
    const { pageNum, pageSize } = this.state;
    this.getAllPosts({ pageNum: pageNum + 1, pageSize });
    if (this.props.location.state) {
      const { run } = this.props.location.state;
      if (run) {
        this.setState({ showNextJoyRide: run });
      } else {
        return;
      }
    }
  }



  getAllPosts = params => {
    this.setState({ fetching: true });
    adminVerifiedService
      .getAllPost(params)
      .then(response => {
        response &&
          this.setState({
            data: response,
            pages: Math.ceil(response.count / params.pageSize),
            error: null,
            fetching: false
          });
      })
      .catch(error => this.setState({ error, fetching: false }));
  };

  fetchData = () => {
    const { pageNum, pageSize, filterParams } = this.state;
    let params = { pageNum: pageNum + 1, pageSize };
    if (filterParams) {
      params = { ...filterParams, ...params };
    }
    this.getAllPosts(params);
  };

  setPageNumber = pageIndex => {
    this.setState({ pageNum: pageIndex }, () => this.fetchData());
  };

  setPageSize = (pageSize, pageIndex) => {
    this.setState({ pageSize, pageNum: pageIndex }, () => this.fetchData());
  };

  filterData = params => {
    const filterParams = {
      ...this.state.filterParams,
      ...params
    };
    this.setState({ filterParams, pageNum: 0 }, () => this.fetchData());
  };

  selectRow = selectedRow => {
    this.setState({ selectedRow: selectedRow.original, hasParams: true });
  };

  showConfirmation = selectedRow => {
    this.setState({
      selectedRow: selectedRow.original,
      showModal: !this.state.showModal
    });
  };

  unApprovedPost = item => {
    if (item.id) {
      adminVerifiedService
        .unApprovedPost(item.id)
        .then(response => {
          this.setState({ response, error: null, submitting: false });
          this.fetchData();
          toast.success("Post successfully unapproved", {
            position: toast.POSITION.TOP_RIGHT,
            autoClose: 4000
          });
        })
        .catch(error => this.setState({ error, submitting: false }));
    }

    this.setState({
      showModal: !this.state.showModal
    });
  };
  //===================TOUR SECTION===================//
  routeChange = () => {
    this.props.history.push({
      pathname: `/admincreatecategories`,
      state: { run: true }
    });
  };

  setNextJoyRide = () => {
    this.setState({ showNextJoyRide: false });
  };

  render() {
    const {
      fetching,
      data,
      pages,
      pageNum,
      pageSize,
      error,
      filterParams,
      hasParams,
      selectedRow,
      showNextJoyRide
    } = this.state;

    return (
      <div>
        <AdminVerifiedContentTable
          fetching={fetching}
          hasParams={hasParams}
          selectedRow={selectedRow}
          data={data}
          selectRow={this.selectRow}
          error={error}
          getAllPosts={this.getAllPosts}
          pages={pages}
          page={pageNum}
          filterParams={filterParams}
          pageSize={pageSize}
          filterData={this.filterData}
          setPageNumber={this.setPageNumber}
          setPageSize={this.setPageSize}
          postId={selectedRow}
          showNextJoyRide={showNextJoyRide}
          routeChange={this.routeChange}
          setNextJoyRide={this.setNextJoyRide}
          showModal={this.showConfirmation}
        />
      </div>
    );
  }
}

export default ManageAdminVerifiedContent;
